<template>
  <div class="nav">
    <ul>
      <li style="width: 0;height: 100%;"></li>
      <li :class="activePath === '/home/index' ? 'active' : ''" @click="push('/home/index')">{{ $tc('Navigation.homePage') }}</li>
      <li :class="activePath === '/home/history' ? 'active' : ''" @click="leavePage()">{{ $tc('Navigation.ComplaintInquiry') }}</li>
    </ul>
    <el-dialog
      class="statement"
      :visible.sync="dialogVisible"
      center
      width="600px"
    >
      <div style="text-align: center;margin-top: 10px;font-size: 22px;font-weight: bold">{{ $t('statementText.warning') }}</div>
      <br><br>
      <div >
       <p style="'word-break: normal;font-size: 20px;'" :style="language === 'zh' ? 'text-align: center' : 'text-align: left'">{{ $t('statementText.warningContent') }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">{{ $t('statementText.warningButton1') }}</el-button>
        <el-button type="primary" @click="toHistory()">{{ $t('statementText.warningButton2') }}</el-button>
     </span>
    </el-dialog>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        dialogVisible: false,
        formKey: '',
      }
    },
    computed: {
      key() {
        return this.$store.getters.key
      },
      ...mapGetters([
        'sidebar',
        'name',
        'key',
        'device',
        'language'
      ]),
      activePath() {
        return this.$route.path
      }
    },
    created() {
    },
    methods: {
      toHistory(){
        this.push('/home/history')
        this.dialogVisible = false;
        this.$store.dispatch('app/setKey', '')
      },
      leavePage(){
        if (this.key === ''){
          this.push('/home/history')
        }else {
          this.dialogVisible=true;
        }
      },
      toggleSideBar() {
        this.$store.dispatch('app/toggleSideBar')
      },
      push(path) {
        this.$router.push(path)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .nav {
    height: 46px;
    width: 100%;
    min-width: 1140px;
    background-color: #7ebaea;
    box-sizing: border-box;
    padding: 0;
    margin: 0 auto;

    ul {
      height: 100%;
      padding: 0;
      width: 1140px;
      font-size: 16px;
      margin: 0 auto;

      li {
        width: 140px;
        text-align: center;
        line-height: 46px;
        float: left;
        list-style: none;
        position: relative;
        cursor: pointer;
        color: #fff;
        &.active{
          background-color: #5e8dcc;
        }
        &:hover{
          background-color: #3cabff;
        }
        &:after {
          content: "";
          display: inline-block;
          position: absolute;
          right: -2px;
          top: calc(50% - 8px);
          height: 16px;
          width: 2px;
          background: #66baff;
        }
      }
      .el-dropdown > span {
        width: 100px;
        text-align: center;
        font-size: 16px;
        text-decoration: none;
        color: #1989fa;
        opacity: .5;
        display: block;
        padding: 0 22px;
        cursor: pointer;
      }
    }
  }
</style>
